<!-- 右侧内容区域 -->
<template>
  <section class="app-main" :class="{ 'equipment-detail-fms': isEquipmentDetailFms }">
    <router-view v-slot="{ Component, route }">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="tagsViewStore.cachedViews">
          <component v-if="!route.meta.link" :is="Component" :key="route.path" />
        </keep-alive>
      </transition>
    </router-view>
    <iframe-toggle />
  </section>
</template>

<script setup>
import iframeToggle from './IframeToggle/index'
import useTagsViewStore from '@/store/modules/tagsView'
import { useRoute } from 'vue-router'

const route = useRoute()
const tagsViewStore = useTagsViewStore()

// 判断是否是 equipmentDetail/fms 路由--主要作用去掉内边距
const isEquipmentDetailFms = computed(() => {
  const path = route.path
  const name = route.name
  return path.includes('equipmentDetail/fms') ||
    path.includes('equipmentDetail/pitchPeak') ||
    name === 'equipmentDetailFms' ||
    name === 'PitchPeak'
})

// 监听路由变化，自动添加 iframe 视图
watchEffect(() => {
  if (route.meta?.link) {
    tagsViewStore.addIframeView(route)
  }
})
</script>

<style lang="scss" scoped>
.app-main {
  width: 100%;
  height: calc(100vh - 93px);
  // height: calc(100vh - 65px);
  position: relative;
  overflow: auto;
  padding: 16px;

  // padding-bottom: 20px;

  // 隐藏滚动条 - Webkit 浏览器 (Chrome, Safari, Edge)
  &::-webkit-scrollbar {
    display: none;
  }

  // 隐藏滚动条 - Firefox 浏览器
  scrollbar-width: none;

  // 隐藏滚动条 - IE/Edge 浏览器
  -ms-overflow-style: none;
}

.app-main.equipment-detail-fms {
  padding: 0;
}
</style>

<style lang="scss">
::-webkit-scrollbar {
  width: 8px;
  height: 4px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #E6E6E6;
  border-radius: 3px;
}
</style>
